// Module
var code = "<div class=\"info-page\"> <div> <i class=\"mdi mdi-alert-circle-outline mdi-36px\"></i><br> <span class=\"title\" data-i18n=\"msg_info_store_only\"></span> <hr> <span class=\"desc\" data-i18n=\"msg_info_select_store\"></span> </div> </div> ";
// Exports
export default code;